import { BodyText } from "@/components/ui";
import type { PatientDemographics } from "../types/patientDemographics";
import type { PatientVitals } from "../types/patientVitals";
import { formatPatientAgeGender } from "../utils/formatPatientAgeGender";
import { Vitals } from "./Vitals";
interface DemographicsInfoProps {
  demographics: PatientDemographics["demographics"];
  vitals: PatientVitals | undefined;
}

export const DemographicsInfo = ({
  demographics,
  vitals,
}: DemographicsInfoProps) => {
  if (!demographics) return null;
  return (
    <>
      <BodyText size="md">
        {formatPatientAgeGender({
          age: demographics.age,
          dob: demographics.dob,
          administrativeGender: demographics.administrativeGender,
          genderIdentity: demographics.genderIdentity,
          preferredPronouns: demographics.preferredPronouns,
        })}
      </BodyText>
      <Vitals vitals={vitals} />
    </>
  );
};
